import { cn } from '@/lib/utils'
import { useUIStore } from '@/store/ui-store'
import { useIsLoggedIn } from '@ekonavi/auth'
import { Earth, FileText, User, Wallet } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { useResolveNavigate } from '../hooks/use-resolve-navigate'
import { Button } from './ui/button-comp'

export function MobileFooter() {
	const resolveNavigate = useResolveNavigate()
	const location = useLocation()
	const isLoggedIn = useIsLoggedIn()
	const { editorMode, editorActions, isSaving } = useUIStore()

	const { onSave, onCancel, saveLabel = 'Salvar', cancelLabel = 'Cancelar' } = editorActions
	// useEffect(() => {
	// 	console.log('isSaving', { isSaving })
	// }, [isSaving])
	// Don't show mobile footer on public pages
	if (!isLoggedIn) {
		return null
	}

	// Editor mode: show Save/Cancel buttons
	if (editorMode) {
		return (
			<div className='fixed z-[50] bottom-0 left-0 right-0 h-[58px] border-t border-border/30 bg-secondary'>
				<div className='w-full h-full flex items-center justify-center gap-3 px-4 pb-1'>
					<Button
						variant='ghost'
						size='default'
						onClick={onCancel}
						disabled={isSaving}
						className='flex-1 h-[40px]'>
						{cancelLabel}
					</Button>
					<Button
						variant='default'
						size='default'
						onClick={onSave}
						disabled={isSaving}
						className='flex-1 h-[40px]'>
						{isSaving ? 'Salvando...' : saveLabel}
					</Button>
				</div>
			</div>
		)
	}

	const tabs = [
		{ id: 'projects' as const, label: 'Projetos', icon: Earth, path: '/projetos' },
		{ id: 'reports' as const, label: 'Relatórios', icon: FileText, path: '/relatorios' },
		{
			id: 'dashboard' as const,
			label: 'Painel',
			icon: null,
			path: '/painel',
			className: {
				icon: 'relative rounded-full mb-5 bg-secondary',
				label: 'absolute -bottom-1.5 left-0 right-0 text-center text-sm',
			},
		},
		{ id: 'wallet' as const, label: 'Carteira', icon: Wallet, path: '/carteira' },
		{ id: 'account' as const, label: 'Conta', icon: User, path: '/conta' },
	]

	const handleTabClick = (path: string) => {
		resolveNavigate({ path })
	}

	const currentPath = location.pathname

	const isActive = (path: string) => {
		// Check for exact match or if current path starts with the tab path (for sub-routes)
		return currentPath === path || currentPath.startsWith(path + '/')
	}

	return (
		<div className='fixed z-[50] bottom-0 left-0 right-0 h-[var(--footer-height)]   border-t-[1px]  border-t-black/5 items-center justify-center flex w-full bg-secondary'>
			<div className={`border-t-[1px] border-t-white/30 w-full h-full flex items-center justify-center`}>
				<div className='max-w-6xl mx-auto w-full flex items-center justify-center h-full'>
					{tabs.map(({ id, label, icon: Icon, path, className }: any) => {
						const active = isActive(path)
						return (
							<button
								key={id}
								onClick={() => handleTabClick(path)}
								className={cn(`flex flex-col items-center justify-center h-full flex-1 text-lg transition-colors cursor-pointer ${active ? 'text-orange-800' : 'text-muted-foreground'}`, className?.icon)}>
								{Icon && (
									<Icon
										size={30}
										strokeWidth={2}
										className='mb-0.5'
									/>
								)}
								<span className={cn('font-semibold text-sm', className?.label)}>{label}</span>
							</button>
						)
					})}
				</div>
			</div>
		</div>
	)
}
